import { tempMeeApi } from '~/services/api';
import type {
  IVerifyOtpApiEnvelope,
  IVerifyOtpApiPayload,
  IVerifyOtpApiResponse,
} from '../types/ForgotPassword.api';

export const verifyOtp = async (
  payload: IVerifyOtpApiPayload,
): Promise<IVerifyOtpApiResponse> => {
  const { data: envelope } = await tempMeeApi.post<IVerifyOtpApiEnvelope>(
    '/auth-service/otp/verification',
    payload,
  );
  return envelope.data;
};
